import { FAIconName, Icon } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";
import { joinTestIDs } from "@/utils/string.util";

interface TopRightDismissButtonProps extends ViewWithTestID {
  color?: ColorToken;
  onPress: () => Promise<void> | void;
}

const TopRightDismissButton = ({
  color = ColorToken.NeutralBackgroundPrimary,
  onPress,
  testID,
}: TopRightDismissButtonProps) => {
  return (
    <Box
      onPress={(e) => {
        if (isWeb()) e.stopPropagation();
        void onPress();
      }}
      position="absolute"
      right={18}
      top={18}
      zIndex={1}
    >
      <Icon
        color={color}
        name={FAIconName.Times}
        size="md"
        testID={joinTestIDs(testID, "dismiss-icon")}
      />
    </Box>
  );
};

export default TopRightDismissButton;
